/* Dopo signup/login Ghost: ?redirect=… sulla home → torna al path richiesto (claim, play, …). */
(function () {
    var PLAY = '/play';

    function normalizePath(pathname) {
        var p = (pathname || '/').replace(/\/$/, '') || '/';
        return p;
    }

    function resolveRedirectTarget(raw) {
        if (!raw) return null;
        try {
            var url = new URL(raw, window.location.origin);
            if (url.origin !== window.location.origin) return null;
            var p = normalizePath(url.pathname);
            if (p === '/play') return PLAY;
            if (p.indexOf('/play/') === 0) return url.pathname + url.search + url.hash;
            if (p.indexOf('/claim/') === 0) return url.pathname + url.search + url.hash;
            // Same-origin relative redirects (e.g. /status) — allow without open redirect.
            if (p === '/' || p.indexOf('/.') === 0) return null;
            return url.pathname + url.search + url.hash;
        } catch (e) {
            return PLAY;
        }
    }

    function hasGhostSession() {
        return fetch('/members/api/session/', { credentials: 'include', cache: 'no-store' })
            .then(function (res) { return res.status !== 204 && res.ok; })
            .catch(function () { return false; });
    }

    var params = new URLSearchParams(window.location.search);
    var redirectTarget = resolveRedirectTarget(params.get('redirect'));
    var onHome = normalizePath(window.location.pathname) === '/';

    function goRedirect() {
        window.location.replace(redirectTarget || PLAY);
    }

    function pollRedirect(maxTries, intervalMs) {
        var tries = 0;
        var timer = window.setInterval(function () {
            hasGhostSession().then(function (ok) {
                if (ok) {
                    window.clearInterval(timer);
                    goRedirect();
                } else if (++tries >= maxTries) {
                    window.clearInterval(timer);
                }
            });
        }, intervalMs);
    }

    function afterPortalClose() {
        if (!onHome) return;
        if (!redirectTarget) return;
        pollRedirect(25, 300);
    }

    function boot() {
        if (redirectTarget && onHome) {
            hasGhostSession().then(function (ok) {
                if (ok) {
                    goRedirect();
                } else {
                    pollRedirect(25, 300);
                }
            });
        }

        if (!onHome) return;

        var sawPortal = false;
        window.addEventListener('hashchange', function () {
            var hash = window.location.hash || '';
            if (hash.indexOf('/portal/sign') >= 0 || hash.indexOf('/portal/account') >= 0) {
                sawPortal = true;
            } else if (sawPortal && hash.indexOf('/portal/') < 0) {
                afterPortalClose();
            }
        });
    }

    boot();
})();
